





















































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
// axios请求
import { chargeRecordList, chargingList, chargingPileBrand } from '@/api/chargingpile-management/index';
import Utils from '@root/utils/common';
import * as _ from 'lodash';
import OrganizationSearch from '@/components/organization-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import { enterOrExit } from '@/api/exception-management/index';
@Component({
  name: 'ChargerecordList',
  components: {
    ParkingLotSearch,
    OrganizationSearch,
    PlateInput
  }
})
// @Component
export default class DeviceOperation extends Mixins(TableMixin, TableWidthMixin) {
  //搜索参数
  private filterParam: any = {
    parkId: [], //选中的车场
    plate: '',
    orgdepId: '', //机构Id
    brandId: '',
    recordId: '',
    sendCouponStatus: ''
  };
  tableLoading: boolean = false;
  tableData: any[] = []; // 表数据
  plateInputModel: boolean = false;
  detailFlag: boolean = false;
  brandList: any[] = []; //充电品牌列表
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '所属机构',
        dataIndex: 'orgdepName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '充电品牌',
        dataIndex: 'brandName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '停车订单号',
        dataIndex: 'orderId',
        width: 260,
        scopedSlots: { customRender: 'orderId' }
      },
      {
        title: '充电记录号',
        dataIndex: 'recordId',
        width: 220,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '充电开始时间',
        dataIndex: 'rechargeStartTime',
        width: 220,
        customRender: (text: any) => text || '--'
      },
      {
        title: '充电结束时间',
        dataIndex: 'rechargeEndTime',
        width: 220,
        customRender: (text: any) => text || '--'
      },
      {
        title: '单次充电时长（分钟）',
        dataIndex: 'rechargeTime',
        width: 180,
        customRender: (text: any) => text || '--'
      },
      // {
      //   title: '累计时长（分钟）',
      //   dataIndex: 'totalRechargeTime',
      //   width: 160,
      // },
      {
        title: '单次充电量（度）',
        dataIndex: 'rechargeAmount',
        width: 160,
        customRender: (text: any) => (text === '' ? '--' : text || '--')
      },
      {
        title: '是否发放优惠',
        dataIndex: 'sendCouponStatus',
        width: 140,
        // customRender: (text: any) => (text == '00' ? '是' : '否' || '--')
        customRender: (text: any) => text || '--'
        // scopedSlots: { customRender: 'sendCouponStatus' }
      },
      {
        title: '总优惠数额',
        dataIndex: 'discountRechargeValue',
        width: 160,
        // customRender: (text: any) => text || '--'
        scopedSlots: { customRender: 'discountRechargeValue' }
      },
      {
        title: '同步时间',
        dataIndex: 'operateTime',
        width: 220,
        customRender: (text: any) => text || '--'
      }
      // {
      //   title: '单次充电量（度）',
      //   dataIndex: 'operateTime1',
      //   width: 220,
      // },
    ];
  }
  // 车牌改变
  plateChange([plateHead, plateTail]: any, b: any) {
    this.filterParam.plate = plateHead + plateTail;
  }
  // 生命周期初始化表单列表
  created() {
    // this.fetchTableData()
    this.getChargingList();
  }
  /**
   * 请求数据列表
   */
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkId, ...rest } = this.filterParam;
      const { status, code, msg, data } = await chargeRecordList({
        ...rest,
        parkId: this.filterParam.parkId.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkId: defaultParkIdList, //选中的车场
      plate: '',
      orgdepId: '', //机构Id
      brandId: '',
      recordId: '',
      sendCouponStatus: ''
    };
    this.searchTable();
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }

  //跳转至停车记录页面
  async toDetail(record) {
    if (record) {
      if (this.detailFlag) return;
      this.detailFlag = true;
      try {
        const { data } = await enterOrExit({ orderId: record.orderId });
        if (!data) return this.$message.error('暂无停车记录详情');
        //在场
        if (data == '00')
          return this.$router.push({ name: 'ENTER_CAR_DETAIL', params: { pkOrderId: record.orderId, from: '01' } });
        if (data == '01')
          //出场
          return this.$router.push({
            name: 'PARKING_RECORD_DETAIL',
            params: { pkOrderId: record.orderId, from: '01' }
          });
      } catch (e) {
        this.$message.error((e && e.msg) || '系统异常请稍后再试');
      } finally {
        this.detailFlag = false;
      }
    }
  }
  activated() {
    if (this.$route.params.recordId) {
      this.filterParam.recordId = this.$route.params.recordId;
    }
    this.fetchTableData();
  }
  orgdepId: any = '';
  handleOrgChange(val) {
    this.orgdepId = val;
    this.getChargingList();
  }
  //获取充电品牌列表
  //获取充电品牌列表
  async getChargingList() {
    try {
      const res = await chargingPileBrand({});
      this.brandList = res.data.map(item => {
        return { label: item.brandName, value: item.pkChargeBrandId };
      });
      // this.filterParam.brandId = ''
    } catch (e) {
      this.$message.error((e && e.msg) || '系统异常请稍后再试');
    }
  }
  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
